import { KIT_FONT_FACES } from 'fym-shared/src/music24/releaseThemes';

type Ctx = CanvasRenderingContext2D;

/** The words of the watermark. A product name: it is the same in every language. */
export const COVER_WATERMARK_TEXT = 'Made with MUSIC24';

/**
 * The Music24 watermark of a Free, trial or public download (owner decision D7): a small dark pill
 * with the words in the lower right corner, at every size of the cover.
 */
export function drawCoverWatermark(ctx: Ctx, side: number): void {
  const face = KIT_FONT_FACES.grotesk;
  const fontPx = side * 0.026;
  ctx.save();
  ctx.font = `700 ${fontPx}px '${face.family}', ${face.fallback}`;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';
  const padX = fontPx * 0.8;
  const height = fontPx * 2;
  const width = ctx.measureText(COVER_WATERMARK_TEXT).width + padX * 2;
  const x = side - width - side * 0.03;
  const y = side - height - side * 0.03;
  const radius = height / 2;
  ctx.fillStyle = 'rgba(10, 9, 17, 0.72)';
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = 'rgba(255, 255, 255, 0.94)';
  ctx.fillText(COVER_WATERMARK_TEXT, x + padX, y + height / 2);
  ctx.restore();
}
